import { render } from "./DeleteFilterItemsModal.vue?vue&type=template&id=4940334d"
import script from "./DeleteFilterItemsModal.vue?vue&type=script&lang=js"
export * from "./DeleteFilterItemsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__